import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh/faq")({
  beforeLoad: () => {
    throw redirect({ to: "/zh", replace: true });
  },
});
